import React from 'react';

import { useT } from 'client/i18n/hooks/useT';
import Icon from 'client/shared/Icon';
import { trackEvent } from 'client/modules/analytics';
import { Button } from 'client/shared/Button/NewButton';
import {
  PlatformBadgeContent,
  PlatformBadgeIconContainer,
  PlatformBadgeLabel,
} from './styles';

type PlatformBadgeProps = {
  contentClass?: string;
  platformName: string;
  url: string;
  clickEventLocation: string;
  clickEventSection?: string;
};

export const PlatformBadge = ({
  contentClass,
  platformName,
  url,
  clickEventLocation,
  clickEventSection,
}: PlatformBadgeProps) => {
  const t = useT();

  const PLATFORM_OPTIONS = {
    apple: {
      iconType: 'apple_logo',
      label: t(
        'PlatformBadge.AppleStore',
        'App Store',
        'Button to go to the Apple Store for the app'
      ),
      eventPlatformName: 'App Store',
    },
    google: {
      iconType: 'google_play_logo',
      label: t(
        'PlatformBadge.GooglePlay',
        'Google Play',
        'Button to go to the Google Play store for the app'
      ),
      eventPlatformName: 'Play Store',
    },
  } as { [key: string]: any };
  const { iconType, label, eventPlatformName } = PLATFORM_OPTIONS[platformName];

  return (
    <Button
      href={url}
      kind="link"
      target="_blank"
      color="onDark"
      rel="noopener noreferrer"
      onClick={() => {
        if (clickEventLocation) {
          const eventLabel = clickEventSection
            ? `${clickEventSection} ${eventPlatformName} Button`
            : `${eventPlatformName} Button`;
          trackEvent(
            null,
            {
              eventCategory: clickEventLocation,
              eventAction: 'Click',
              eventLabel,
            },
            // eslint-disable-next-line
            { providers: [ga] }
          );
        }
      }}
    >
      <PlatformBadgeContent className={contentClass}>
        <PlatformBadgeIconContainer>
          <Icon type={iconType} fillColor="#ffffff" />
        </PlatformBadgeIconContainer>
        <PlatformBadgeLabel>{label}</PlatformBadgeLabel>
      </PlatformBadgeContent>
    </Button>
  );
};
